import axios from 'axios';
import { temporaryAccessToken } from '../config/app';

export function addFiskTag(fiskParams: {}, API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/fisks/tags`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: token,
  };
  return axios.post(url, fiskParams, { headers });
}

export function addMember(courseId): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const API_HOST = 'https://developer-api.fiskkit.com';
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/course/addmember`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: token,
  };
  return axios.post(url, courseId, { headers });
}

export function incrementRespect(commentId: number, API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/fisks/${commentId}/respects`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: token,
  };
  const data = {
    comment_id: commentId,
  };
  return axios.post(url, data, { headers });
}

export function getFisks(articleId: string, API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  // tslint:disable-next-line:max-line-length
  const url = `${API_HOST}/api/v1/fisks?limit=20&article_id=${articleId}&sort=respect|desc&most_respected_comment=1`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(url, { headers });
}

export function getComments(articleId: string, API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  // tslint:disable-next-line:max-line-length
  const url = `${API_HOST}/api/v1/comments/${articleId}`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(url, { headers });
}

export function getFiskTest(API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  // tslint:disable-next-line:max-line-length
  const url = `${API_HOST}/api/v1/fisks/6912`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(url, { headers });
}

// export function getUserInfo(API_HOST): Promise<any> {
//   // user access token
//   const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
//   // prepare url
//   // const API_HOST = 'https://developer-api.fiskkit.com';
//   const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
//   // tslint:disable-next-line:max-line-length
//   const url = `${API_HOST}/api/v1/users/me`;
//   const testUrl = corsAnywhere + url;
//   const headers = {
//     // 'Content-Type': 'application/json',
//     Authorization: `Bearer ${token}`,
//   };
//   return axios.get(url, { headers });
// }

export function getUserCourses(userId): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const API_HOST = 'https://developer-api.fiskkit.com';
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  // tslint:disable-next-line:max-line-length
  const url = `${API_HOST}/api/v1/users/${userId}/courses`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(testUrl, { headers });
}

export function getAllCourses(): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const API_HOST = 'https://developer-api.fiskkit.com';
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  // tslint:disable-next-line:max-line-length
  const url = `${API_HOST}/api/v1/course/all`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(url, { headers });
}


// export function getCurrentFisk(fisk_id: number, API_HOST: string): Promise<any> {
//   // user access token
//   const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
//   // prepare url
//   const url = `${API_HOST}/api/v1/fisks/${fisk_id}`;
//   const headers = {
//     // 'Content-Type': 'application/json',
//     Authorization: `Bearer ${token}`,
//   };
//   return axios.get(url, { headers });
// }

// get all child fisks on level 1 (article sentence -> comments -> CHILD FISKS to particular comment)
export function getChildFisks(parent_fisk_id: number, API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const url = `${API_HOST}/api/v1/fisks/${parent_fisk_id}/fisks`;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.get(url, { headers });
}

export function addCourse(course: { course: string }): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const API_HOST = 'https://developer-api.fiskkit.com';
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/course/add`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return axios.post(url, course, { headers });
}

// tslint:disable-next-line:max-line-length
export function putUserComment(
  fisk_id: number,
  body: string,
  article_id: string,
  parent_fisk_id: number,
  parent_sentence_id: number,
  tag_ids: any[],
  API_HOST: string
): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/fisks/${fisk_id}`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  const data = {
    body,
    article_id,
    parent_fisk_id,
    parent_sentence_id,
    tag_ids,
  };
  return axios.put(url, data, { headers });
}

// PUT - update user comment
export function postUserComment(
  API_HOST: string,
  article_id: string,
  body: string,
  parent_fisk_id: number,
  parent_sentence_id: number,
  tag_ids: any[],
): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  // const url = `${API_HOST}/api/v1/comments/${commentId}`;
  const url = `${API_HOST}/api/v1/fisks`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  const data = {
    article_id,
    body,
    parent_fisk_id,
    parent_sentence_id,
    tag_ids,
  };
  return axios.post(url, data, { headers });
}

// PUT - update user data
export function updateUserData(data: { bio: string, location: string }): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const API_HOST = 'https://developer-api.fiskkit.com';
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/users/me`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  return axios.put(url, data, { headers });
}

export function decrementRespect(commentId: number, API_HOST: string): Promise<any> {
  // user access token
  const token = localStorage.getItem('fiskkit.access_token') || temporaryAccessToken;
  // prepare url
  const corsAnywhere = 'https://cors-anywhere.herokuapp.com/';
  const url = `${API_HOST}/api/v1/fisks/${commentId}/respects`;
  const testUrl = corsAnywhere + url;
  const headers = {
    // 'Content-Type': 'application/json',
    Authorization: token,
  };

  return axios.delete(url, { headers });
}
